import * as Yup from "yup";
import { Track, TrackFile, TrackFileType, User } from "../../proto/api_pb";
import { Dispatch, SetStateAction } from "react";
import {
  UploadCardStatusInfo,
  UploadedFileInfo,
} from "../FileUploadStatusCard/types";

export const newTrack = {
  artist: "",
  hasSong: undefined,
  coverArtUpload: undefined,
  genres: "",
  album: "",
  newCollaborator: {
    username: "",
  },
};

export const TRACK_VALIDATION_SCHEMA = Yup.object().shape({
  fileLabel: Yup.string().optional(),
  fileUpload: Yup.mixed().required("required"),
  bpm: Yup.number()
    .min(0, "Amount must be greater than 0")
    .max(200, "Amount must be less than 200"),
  newCollaborator: Yup.mixed().optional(),
});

export const newAddTrack = {
  fileUpload: undefined,
  fileLabel: "",
  bpm: 0,
  newCollaborator: {
    username: "",
  },
};

export const fileTypes = [
  {
    option: "Specify the file type",
    value: TrackFileType.TRACK_FILE_TYPE_UNSPECIFIED,
  },
  {
    option: "Session",
    value: TrackFileType.TRACK_FILE_TYPE_SESSION,
  },
  {
    option: "Stem Vocal",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_VOCAL,
  },
  {
    option: "Stem Drum",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_DRUM,
  },
  {
    option: "Stem Melody",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_MELODY,
  },
  {
    option: "Stem Instrument",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_INSTRUMENT,
  },
  {
    option: "Stem Bassline",
    value: TrackFileType.TRACK_FILE_TYPE_STEM_BASSLINE,
  },
  {
    option: "Lyrics",
    value: TrackFileType.TRACK_FILE_TYPE_LYRICS,
  },
  {
    option: "Artwork",
    value: TrackFileType.TRACK_FILE_TYPE_ARTWORK,
  },
  {
    option: "Other",
    value: TrackFileType.TRACK_FILE_TYPE_OTHER,
  },
];

export interface TrialEndWarningModalProps {
  trialEndTime: number;
  userId: string;
  stripeCustomerId: string;
}

export interface SendInviteModalProps {
  isSendInviteModalOpen: boolean;
  setIsSendInviteModalOpen: Dispatch<SetStateAction<boolean>>;
  userId: string;
}

export interface ModalProp {
  isModalOpen: boolean;
  selectedUser: User;
  handleModal: (user: User) => void;
}

export interface TrackDeleteConfirmModalProps {
  deleteConfirmModalOpen: boolean;
  closeDeleteConfirmModal: () => void;
  handleDeleteTrack: () => Promise<void>;
  type?: string;
}

export interface MultipleFilesUploadModalProps {
  open: boolean;
  handleClose: any;
  track?: Track;
  handleFileAdded?: () => void;
  setUploadingFilesDetailsList: Dispatch<SetStateAction<UploadedFileInfo[]>>;
  setIsUploading: Dispatch<SetStateAction<boolean>>;
  setUploadingCardsStatusList: Dispatch<SetStateAction<UploadCardStatusInfo[]>>;
  parentFolderId?: string;
}

export interface CreateFolderModalProps {
  setIsCreateFolderModalOpen: Dispatch<SetStateAction<boolean>>;
  isCreateFolderModalOpen: boolean;
  parentFolderId?: string;
  getAllFoldersList: () => Promise<void>;
}

export interface FileTrackLinkingModalProps {
  isFileTrackLinkingModalOpen: boolean;
  setIsFileTrackLinkingModalOpen: Dispatch<SetStateAction<boolean>>;
  file: TrackFile;
}
